import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import type { ClientNotification } from '../../../shared/domain/notifications/types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/notifications/syncNotifications' }

type Params = never

type Body = {
    lastSyncTime?: Date
    notifications: UUID[]
    // Avoid scheduled instance notifications being sent to old clients that aren't compatible
    includeScheduledInstanceNotifications?: boolean
}

type Query = { version?: number }

type Output = {
    syncTime: Date
    notifications: ClientNotification[]
}

export type SyncNotificationsEndpoint = Endpoint<Params, Body, Query, Output>

export const syncNotificationsRequest = (request: Request, args: RequestArgs<SyncNotificationsEndpoint>) =>
    request<SyncNotificationsEndpoint>(route, args)
